import type { ApiRet, DataList, ListParams, ListSPResp } from '@spx-portal/shared-types';

import { request } from '@/common/appCtx';

export interface LogListQuery {
  station_id?: number;
  id?: number;
}
export interface LogListSearchParams extends ListParams<LogListQuery> { }

export interface LogListItem {
  import_time: number;
  user_name: string;
  import_type: string;
  import_status: number;
  id: number;
}

export async function getBatchLogList(params: LogListSearchParams):Promise<DataList<LogListItem>> {
  return request.get('/api/wfm/admin/workstation/workstation_batch_log_list', { params }).then((v: ApiRet) => v.data);
}

export async function getSingleLogList(params: LogListSearchParams):Promise<DataList<LogListItem>> {
  return request.get('/api/wfm/admin/workstation/log/list', { params }).then((v: ApiRet) => v.data);
}

export function exportBatchLogList(params: LogListSearchParams) {
  window.open(`/api/wfm/admin/workstation/workstation_batch_log_detail?id=${params.id}`);
}
